import { _ as _defineProperty } from './defineProperty.js';

var name = "@biom3/design-tokens";
var version$1 = "0.4.4";
var main = "./src/index.ts";
var module = "./src/index.ts";
var types = "./src/index.ts";
var directories = {
	css: "css",
	fonts: "fonts"
};
var license = "Apache-2.0";
var sideEffects = false;
var repository = {
	type: "git",
	url: "git+https://github.com/immutable/biom3.git"
};
var scripts = {
	lint: "npm run typecheck && npm run lint:check",
	"lint:check": "biome check ./",
	"lint:check:fix": "biome check --apply ./",
	"format:fix": "biome format --write ./",
	typecheck: "tsc --noEmit",
	prebuild: "rm -rf ./dist",
	build: "npm run build:tokens; npm run build:ts",
	pack: "npm pack",
	"prebuild:tokens": "rm  -rf ./css; mkdir css;",
	"build:tokens": "ts-node ./src/packageScripts/dumpTokens.ts",
	"build:ts": "tsup src/index.ts --dts",
	"publish-package": "if can-npm-publish; then cd dist; npm publish --access public; else echo 'Skipping package npm publish'; fi"
};
var dependencies = {
	"lodash.get": "^4.4.2"
};
var devDependencies = {
	"@biomejs/biome": "1.7.0",
	"@types/node": "^18.15.11",
	"can-npm-publish": "^1.3.6",
	nodemon: "^2.0.20",
	"prepend-file": "^2.0.1",
	"@repo/ts-config": "*",
	"ts-node": "^10.9.2",
	tsup: "^7.2.0",
	typescript: "^5.4.5"
};
var packageData = {
	name: name,
	version: version$1,
	main: main,
	module: module,
	types: types,
	directories: directories,
	license: license,
	sideEffects: sideEffects,
	repository: repository,
	scripts: scripts,
	dependencies: dependencies,
	devDependencies: devDependencies
};

var borderRadius = {
  x1: "2px",
  x2: "4px",
  x3: "6px",
  x4: "8px",
  x5: "10px",
  x6: "12px",
  x7: "14px",
  x8: "16px",
  x9: "18px",
  x10: "20px",
  x11: "22px",
  x12: "24px",
  x13: "26px",
  x14: "28px",
  x15: "30px",
  x16: "32px",
  x17: "34px",
  x18: "36px",
  x19: "38px",
  x20: "40px",
  x21: "42px",
  x22: "44px",
  x23: "46px",
  x24: "48px",
  x25: "50px"
};

var breakpoint = {
  small: 450,
  medium: 768,
  large: 1024,
  xLarge: 1280,
  xxLarge: 1536,
  xxxLarge: 1920
};

var font = {
  family: {
    heading: {
      primary: "'Suisse-Intl', sans-serif",
      secondary: "'Suisse-Intl', sans-serif"
    },
    body: {
      primary: "'Roboto', sans-serif",
      secondary: "'Roboto Mono', monospace"
    }
  },
  decoration: {
    underline: "underline",
    lineThrough: "line-through",
    none: "none"
  },
  casing: {
    uppercase: "uppercase",
    none: "none"
  }
};

var motion = {
  normal: {
    gentle: {
      cssDuration: "0.4s",
      jsDuration: 0.4,
      cssEase: "ease-in-out",
      jsEase: "easeInOut"
    },
    fast: {
      cssDuration: "0.25s",
      jsDuration: 0.25,
      cssEase: "ease-in-out",
      jsEase: "easeInOut"
    }
  },
  bounce: {
    gentle: {
      cssDuration: "0.7s",
      jsDuration: 0.7,
      cssEase: "cubic-bezier(0.47, 1.74, 0.41, 0.8)",
      jsEase: [0.47, 1.74, 0.41, 0.8]
    },
    fast: {
      cssDuration: "0.45s",
      jsDuration: 0.45,
      cssEase: "cubic-bezier(0.47, 1.74, 0.41, 0.8)",
      jsEase: [0.47, 1.74, 0.41, 0.8]
    }
  }
};

var spacing = {
  x1: "4px",
  x2: "8px",
  x3: "12px",
  x4: "16px",
  x5: "20px",
  x6: "24px",
  x7: "28px",
  x8: "32px",
  x9: "36px",
  x10: "40px",
  x11: "44px",
  x12: "48px",
  x13: "52px",
  x14: "56px",
  x15: "60px",
  x16: "64px",
  x17: "68px",
  x18: "72px",
  x19: "76px",
  x20: "80px",
  x21: "84px",
  x22: "88px",
  x23: "92px",
  x24: "96px",
  x25: "100px",
  x26: "104px",
  x27: "108px",
  x28: "112px",
  x29: "116px",
  x30: "120px",
  x31: "124px",
  x32: "128px",
  x33: "132px",
  x34: "136px",
  x35: "140px",
  x36: "144px",
  x37: "148px",
  x38: "152px",
  x39: "156px",
  x40: "160px",
  x41: "164px",
  x42: "168px",
  x43: "172px",
  x44: "176px",
  x45: "180px",
  x46: "184px",
  x47: "188px",
  x48: "192px",
  x49: "196px",
  x50: "200px"
};

var text = {
  body: {
    large: {
      regular: {
        fontSize: "20px",
        lineHeight: "28px",
        fontWeight: 400
      },
      bold: {
        fontWeight: 500
      }
    },
    medium: {
      regular: {
        fontSize: "16px",
        lineHeight: "24px",
        fontWeight: 400
      },
      bold: {
        fontWeight: 500
      }
    },
    small: {
      regular: {
        fontSize: "14px",
        lineHeight: "20px",
        fontWeight: 400
      },
      bold: {
        fontWeight: 500
      }
    },
    xSmall: {
      regular: {
        fontSize: "12px",
        lineHeight: "16px",
        fontWeight: 400
      },
      bold: {
        fontWeight: 500
      }
    },
    xxSmall: {
      regular: {
        fontSize: "10px",
        lineHeight: "14px",
        fontWeight: 400
      },
      bold: {
        fontWeight: 500
      }
    }
  },
  caption: {
    medium: {
      regular: {
        fontSize: "14px",
        lineHeight: "20px",
        fontWeight: 400,
        casing: "uppercase",
        letterSpacing: "2px"
      },
      bold: {
        fontSize: "14px",
        lineHeight: "20px",
        fontWeight: 700,
        casing: "uppercase",
        letterSpacing: "2px"
      }
    },
    small: {
      regular: {
        fontSize: "10px",
        lineHeight: "14px",
        fontWeight: 400,
        casing: "uppercase",
        letterSpacing: "2px"
      },
      bold: {
        fontSize: "10px",
        lineHeight: "14px",
        fontWeight: 700,
        casing: "uppercase",
        letterSpacing: "2px"
      }
    }
  },
  heading: {
    xxLarge: {
      regular: {
        fontSize: "96px",
        lineHeight: "112px",
        fontWeight: 600
      },
      light: {
        fontWeight: 400
      },
      bold: {
        fontWeight: 700
      }
    },
    xLarge: {
      regular: {
        fontSize: "64px",
        lineHeight: "72px",
        fontWeight: 600
      },
      light: {
        fontWeight: 400
      },
      bold: {
        fontWeight: 700
      }
    },
    large: {
      regular: {
        fontSize: "40px",
        lineHeight: "48px",
        fontWeight: 600
      },
      light: {
        fontWeight: 400
      },
      bold: {
        fontWeight: 700
      }
    },
    medium: {
      regular: {
        fontSize: "28px",
        lineHeight: "32px",
        fontWeight: 600
      },
      light: {
        fontWeight: 400
      },
      bold: {
        fontWeight: 700
      }
    },
    small: {
      regular: {
        fontSize: "20px",
        lineHeight: "28px",
        fontWeight: 600
      },
      light: {
        fontWeight: 400
      },
      bold: {
        fontWeight: 700
      }
    },
    xSmall: {
      regular: {
        fontSize: "16px",
        lineHeight: "24px",
        fontWeight: 600
      },
      light: {
        fontWeight: 400
      },
      bold: {
        fontWeight: 700
      }
    }
  }
};

var onDarkColors = {
  brand: {
    1: "#F3F3F3",
    2: "#131313",
    3: "#E0E0E0",
    4: "#B6B6B6",
    5: "#36E0F8",
    6: "#1F8290"
  },
  neutral: {
    1000: "#0D0D0D",
    900: "#131313",
    800: "#1C1C1C",
    700: "#202020",
    600: "#252525",
    500: "#292929"
  },
  accent: {
    1: "#F191FA",
    2: "#36E0F8",
    3: "#6FD6F2",
    4: "#61ADEB",
    5: "#99A8EA",
    6: "#E4F4F7",
    7: "#F8D1DE",
    8: "#F2B7DA"
  },
  translucent: {
    emphasis: {
      500: "#F7F7F729",
      // rgba(247, 247, 247, 0.16)
      400: "#F7F7F71F",
      // rgba(247, 247, 247, 0.12)
      300: "#F7F7F71A",
      // rgba(247, 247, 247, 0.10)
      200: "#F7F7F714",
      // rgba(247, 247, 247, 0.08)
      100: "#F7F7F70F" // rgba(247, 247, 247, 0.06)
    },
    standard: {
      1000: "#F7F7F7",
      // rgba(247, 247, 247, 1)
      900: "#F7F7F7E0",
      // rgba(247, 247, 247, 0.88)
      800: "#F7F7F7CC",
      // rgba(247, 247, 247, 0.80)
      700: "#F7F7F7A3",
      // rgba(247, 247, 247, 0.64)
      600: "#F7F7F77A",
      // rgba(247, 247, 247, 0.48)
      500: "#F7F7F73D",
      // rgba(247, 247, 247, 0.24)
      400: "#F7F7F729",
      // rgba(247, 247, 247, 0.16)
      300: "#F7F7F71F",
      // rgba(247, 247, 247, 0.12)
      200: "#F7F7F714",
      // rgba(247, 247, 247, 0.08)
      150: "#F7F7F70F",
      // rgba(247, 247, 247, 0.06)
      100: "#F7F7F70A",
      // rgba(247, 247, 247, 0.04)
      50: "#F7F7F705" // rgba(247, 247, 247, 0.03)
    },
    inverse: {
      1000: "#0D0D0D",
      // rgba(13, 13, 13, 1)
      900: "#0D0D0DE0",
      // rgba(13, 13, 13, 0.88)
      800: "#0D0D0DCC",
      // rgba(13, 13, 13, 0.80)
      700: "#0D0D0DA3",
      // rgba(13, 13, 13, 0.64)
      600: "#0D0D0D7A",
      // rgba(13, 13, 13, 0.48)
      500: "#0D0D0D3D",
      // rgba(13, 13, 13, 0.24)
      400: "#0D0D0D29",
      // rgba(13, 13, 13, 0.16)
      300: "#0D0D0D1F",
      // rgba(13, 13, 13, 0.12)
      200: "#0D0D0D14",
      // rgba(13, 13, 13, 0.08)
      150: "#0D0D0D0F",
      // rgba(13, 13, 13, 0.06)
      100: "#0D0D0D0A",
      // rgba(13, 13, 13, 0.04)
      50: "#0D0D0D05" // rgba(13, 13, 13, 0.03)
    }
  },
  status: {
    guidance: {
      bright: "#36E0F8",
      dim: "#94E9F5 "
    },
    success: {
      bright: "#ABF790",
      dim: "#D5FAC7"
    },
    attention: {
      bright: "#FAFD7E",
      dim: "#F6F8B9"
    },
    fatal: {
      bright: "#FF637F",
      dim: "#F9ABB9"
    }
  },
  fixed: {
    black: {
      1000: "#131313",
      100: "#13131314"
    },
    white: {
      1000: "#F3F3F3",
      100: "#F3F3F314"
    }
  },
  text: {
    highlight: "#36E0F833",
    heading: {
      primary: "base.color.brand.1",
      secondary: "base.color.brand.4",
      emphasis: "base.gradient.1",
      inverse: {
        primary: "base.color.brand.2",
        secondary: "base.color.brand.4"
      }
    },
    body: {
      primary: "base.color.brand.1",
      secondary: "base.color.brand.4",
      inverse: {
        primary: "base.color.brand.2",
        secondary: "base.color.brand.4"
      }
    },
    caption: {
      primary: "base.color.brand.1",
      secondary: "base.color.brand.4",
      inverse: {
        primary: "base.color.brand.2",
        secondary: "base.color.brand.4"
      }
    },
    link: {
      primary: "base.color.accent.1",
      secondary: "base.color.brand.1",
      inverse: {
        primary: "#b026bd",
        secondary: "base.color.brand.2"
      }
    },
    status: {
      success: {
        primary: "base.color.status.success.bright",
        secondary: "base.color.status.success.dim"
      },
      guidance: {
        primary: "base.color.status.guidance.bright",
        secondary: "base.color.status.guidance.dim"
      },
      attention: {
        primary: "base.color.status.attention.bright",
        secondary: "base.color.status.attention.dim"
      },
      fatal: {
        primary: "base.color.status.fatal.bright",
        secondary: "base.color.status.fatal.dim"
      }
    }
  },
  overlay: "base.color.translucent.standard.500"
};
var onDarkShadows = {
  100: "0px 1px 2px rgba(0, 0, 0, 0.16), 0px 1px 4px 1px rgba(0, 0, 0, 0.32)",
  200: "0px 2px 6px 2px rgba(0, 0, 0, 0.16), 0px 1px 2px rgba(0, 0, 0, 0.32)",
  300: "0px 4px 8px 4px rgba(0, 0, 0, 0.16), 0px 1px 4px rgba(0, 0, 0, 0.32)",
  400: "0px 6px 10px 4px rgba(0, 0, 0, 0.16), 0px 2px 4px rgba(0, 0, 0, 0.32)",
  500: "0px 8px 12px 6px rgba(0, 0, 0, 0.16), 0px 4px 4px rgba(0, 0, 0, 0.32)"
};
var onDarkGradients = {
  1: {
    spectrum: "linear-gradient(105.76deg, #F191FA -46.96%, #83E3F0 99.99%)",
    blendMode: "normal",
    svgDefs: "\n    <linearGradient id=\"gradient-1-singleLayer\" x1=\"0\" y1=\"0\" x2=\"24\" y2=\"0.214702\"\n      gradientUnits=\"userSpaceOnUse\">\n      <stop stop-color=\"#C9A2F6\" />\n      <stop offset=\"1\" stop-color=\"#83E3F0\" />\n    </linearGradient>",
    svgDefIds: "gradient-1-singleLayer"
  },
  2: {
    spectrum: "radial-gradient(96.87% 65.57% at 54.34% 93.79%, #FCF5EE 0%, rgba(236, 190, 225, 0) 71.51%), radial-gradient(73.48% 242.97% at 26.54% 26.42%, #A3EEF8 0%, #A4DCF5 17.71%, #A6AEEC 38.02%, #ECBEE1 100%)",
    blendMode: "normal, normal",
    svgDefs: "\n    <radialGradient id=\"gradient-2-bottomLayer\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\"\n      gradientTransform=\"translate(4.7777 4.75595) rotate(44.9817) scale(18.6995 39.6574)\">\n      <stop stop-color=\"#A3EEF8\" />\n      <stop offset=\"0.177083\" stop-color=\"#A4DCF5\" />\n      <stop offset=\"0.380208\" stop-color=\"#A6AEEC\" />\n      <stop offset=\"1\" stop-color=\"#ECBEE1\" />\n    </radialGradient>\n    <radialGradient id=\"gradient-2-topLayer\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\"\n      gradientTransform=\"translate(9.7806 16.8827) rotate(84.265) scale(9.68552 18.5286)\">\n      <stop stop-color=\"#FCF5EE\" />\n      <stop offset=\"0.715135\" stop-color=\"#ECBEE1\" stop-opacity=\"0\" />\n    </radialGradient>",
    svgDefIds: "gradient-2-bottomLayer, gradient-2-topLayer"
  },
  3: {
    spectrum: "radial-gradient(100% 100% at 24.5% 100%, rgba(106, 160, 242, 0.9) 0%, rgba(198, 229, 247, 0) 100%), linear-gradient(81.66deg, rgba(124, 246, 251, 0.48) 9.38%, rgba(254, 253, 248, 0.7) 98.47%), radial-gradient(4009.6% 10453.55% at 0% 0%, #7EF8FE 0%, #7ABFEC 30.21%, #AEC3ED 45.54%, #DEF3F6 61.46%, #FAF9F3 100%)",
    blendMode: "normal, normal, normal",
    svgDefs: "\n    <radialGradient id=\"gradient-3-bottomLayer\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\"\n      gradientTransform=\"rotate(60.6728) scale(36.75 1550.85)\">\n      <stop stop-color=\"#7EF8FE\" />\n      <stop offset=\"0.302083\" stop-color=\"#7ABFEC\" />\n      <stop offset=\"0.455396\" stop-color=\"#AEC3ED\" />\n      <stop offset=\"0.614583\" stop-color=\"#DEF3F6\" />\n      <stop offset=\"1\" stop-color=\"#FAF9F3\" />\n    </radialGradient>\n    <linearGradient id=\"gradient-3-middleLayer\" x1=\"-1.26123e-07\" y1=\"4.8\" x2=\"24\" y2=\"2.16\"\n      gradientUnits=\"userSpaceOnUse\">\n      <stop stop-color=\"#7CF6FB\" stop-opacity=\"0.48\" />\n      <stop offset=\"1\" stop-color=\"#FEFDF8\" stop-opacity=\"0.7\" />\n    </linearGradient>\n    <radialGradient id=\"gradient-3-topLayer\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\"\n      gradientTransform=\"translate(4.41 18) rotate(-52.9472) scale(22.5541)\">\n      <stop stop-color=\"#6AA0F2\" />\n      <stop offset=\"1\" stop-color=\"#C6E5F7\" stop-opacity=\"0\" />\n    </radialGradient>",
    svgDefIds: "gradient-3-bottomLayer,\n      gradient-3-middleLayer,\n      gradient-3-topLayer"
  }
};

var onLightColors = {
  brand: {
    1: "#131313",
    2: "#FFFFFF",
    3: "#E0E0E0",
    4: "#868686",
    5: "#36E0F8",
    6: "#1F8290"
  },
  neutral: {
    1000: "#E7E7E7",
    900: "#ECECEC",
    800: "#F1F1F1",
    700: "#F6F6F6",
    600: "#FAFAFA",
    500: "#FFFFFF"
  },
  accent: {
    1: "#B026BD",
    2: "#1FD3F5",
    3: "#67C6E0",
    4: "#5AA0D9",
    5: "#8395E5",
    6: "#D8EFF4",
    7: "#F5BDD0",
    8: "#EC98CA"
  },
  translucent: {
    emphasis: {
      500: "#0D0D0D1F",
      // rgba(255, 255, 255, 0.12)
      400: "#0D0D0D1A",
      // rgba(255, 255, 255, 0.10)
      300: "#0D0D0D14",
      // rgba(255, 255, 255, 0.08)
      200: "#0D0D0D0F",
      // rgba(255, 255, 255, 0.06)
      100: "#0D0D0D0A" // rgba(255, 255, 255, 0.04)
    },
    standard: {
      1000: "#0D0D0DFF",
      // rgba(13, 13, 13, 1)
      900: "#0D0D0DE0",
      // rgba(13, 13, 13, 0.88)
      800: "#0D0D0DCC",
      // rgba(13, 13, 13, 0.80)
      700: "#0D0D0DA3",
      // rgba(13, 13, 13, 0.64)
      600: "#0D0D0D7A",
      // rgba(13, 13, 13, 0.48)
      500: "#0D0D0D3D",
      // rgba(13, 13, 13, 0.24)
      400: "#0D0D0D29",
      // rgba(13, 13, 13, 0.16)
      300: "#0D0D0D1F",
      // rgba(13, 13, 13, 0.12)
      200: "#0D0D0D1A",
      // rgba(13, 13, 13, 0.10)
      150: "#0D0D0D14",
      // rgba(13, 13, 13, 0.08)
      100: "#0D0D0D0A",
      // rgba(13, 13, 13, 0.04)
      50: "#0D0D0D05" // rgba(13, 13, 13, 0.02)
    },
    inverse: {
      1000: "#FFFFFFFF",
      900: "#FFFFFFE6",
      800: "#FFFFFFCC",
      700: "#FFFFFFA3",
      600: "#FFFFFF7A",
      500: "#FFFFFF3D",
      400: "#FFFFFF29",
      300: "#FFFFFF1F",
      200: "#FFFFFF14",
      150: "#FFFFFF0F",
      100: "#FFFFFF0A",
      50: "#FFFFFF05"
    }
  },
  status: {
    guidance: {
      bright: "#36E0F8",
      dim: "#9AEFFB"
    },
    success: {
      bright: "#ABF790",
      dim: "#D5FAC7"
    },
    attention: {
      bright: "#FBFF6D",
      dim: "#FCFEBF"
    },
    fatal: {
      bright: "#BB3049",
      dim: "#EA6385"
    }
  },
  fixed: {
    black: {
      1000: "#0D0D0D",
      100: "#0D0D0D14"
    },
    white: {
      1000: "#FFFFFF",
      100: "#FFFFFF14"
    }
  },
  text: {
    highlight: "#36E0F866",
    heading: {
      primary: "base.color.brand.1",
      secondary: "base.color.brand.4",
      emphasis: "base.gradient.1",
      inverse: {
        primary: "base.color.brand.2",
        secondary: "base.color.brand.3"
      }
    },
    body: {
      primary: "base.color.brand.1",
      secondary: "base.color.brand.4",
      inverse: {
        primary: "base.color.brand.2",
        secondary: "base.color.brand.3"
      }
    },
    caption: {
      primary: "base.color.brand.1",
      secondary: "base.color.brand.4",
      inverse: {
        primary: "base.color.brand.2",
        secondary: "base.color.brand.3"
      }
    },
    link: {
      primary: "base.color.accent.1",
      secondary: "base.color.brand.1",
      inverse: {
        primary: "#f191fa",
        secondary: "base.color.brand.2"
      }
    },
    status: {
      success: {
        primary: "#426336",
        secondary: "#486D3B"
      },
      guidance: {
        primary: "#206A74",
        secondary: "#22727E"
      },
      attention: {
        primary: "base.color.status.attention.bright",
        secondary: "base.color.status.attention.dim"
      },
      fatal: {
        primary: "base.color.status.fatal.bright",
        secondary: "base.color.status.fatal.dim"
      }
    }
  },
  overlay: "base.color.translucent.standard.600"
};
var onLightShadows = {
  100: "0px 1px 2px rgba(0, 0, 0, 0.16), 0px 1px 4px 1px rgba(0, 0, 0, 0.32)",
  200: "0px 2px 6px 2px rgba(0, 0, 0, 0.16), 0px 1px 2px rgba(0, 0, 0, 0.32)",
  300: "0px 4px 8px 4px rgba(0, 0, 0, 0.16), 0px 1px 4px rgba(0, 0, 0, 0.32)",
  400: "0px 8px 10px 4px rgba(0, 0, 0, 0.16), 0px 2px 4px rgba(0, 0, 0, 0.32)",
  500: "0px 8px 12px 6px rgba(0, 0, 0, 0.16), 0px 4px 4px rgba(0, 0, 0, 0.32)"
};
var onLightGradients = {
  1: {
    spectrum: "linear-gradient(90.68deg, #F191FA 0%, #83E3F0 99.82%)",
    blendMode: "normal",
    svgDefs: "<linearGradient id=\"gradient-1-singleLayer\" x1=\"0\" y1=\"0\" x2=\"24\" y2=\"0.214702\"\n      gradientUnits=\"userSpaceOnUse\">\n      <stop stop-color=\"#F191FA\" />\n      <stop offset=\"1\" stop-color=\"#83E3F0\" />\n    </linearGradient>",
    svgDefIds: "gradient-1-singleLayer"
  },
  2: {
    spectrum: "radial-gradient(96.87% 65.57% at 54.34% 93.79%, #FCF5EE 0%, rgba(236, 190, 225, 0) 71.51%), radial-gradient(73.48% 242.97% at 26.54% 26.42%, #A3EEF8 0%, #A4DCF5 17.71%, #A6AEEC 38.02%, #ECBEE1 100%)",
    blendMode: "normal, normal",
    svgDefs: "<radialGradient id=\"gradient-2-bottomLayer\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\"\n      gradientTransform=\"translate(4.7777 4.75595) rotate(44.9817) scale(18.6995 39.6574)\">\n      <stop stop-color=\"#A3EEF8\" />\n      <stop offset=\"0.177083\" stop-color=\"#A4DCF5\" />\n      <stop offset=\"0.380208\" stop-color=\"#A6AEEC\" />\n      <stop offset=\"1\" stop-color=\"#ECBEE1\" />\n    </radialGradient>\n    <radialGradient id=\"gradient-2-topLayer\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\"\n      gradientTransform=\"translate(9.7806 16.8827) rotate(84.265) scale(9.68552 18.5286)\">\n      <stop stop-color=\"#FCF5EE\" />\n      <stop offset=\"0.715135\" stop-color=\"#ECBEE1\" stop-opacity=\"0\" />\n    </radialGradient>",
    svgDefIds: "gradient-2-bottomLayer, gradient-2-topLayer"
  },
  3: {
    spectrum: "radial-gradient(100% 100% at 24.5% 100%, rgba(106, 160, 242, 0.9) 0%, rgba(198, 229, 247, 0) 100%), linear-gradient(81.66deg, rgba(124, 246, 251, 0.48) 9.38%, rgba(254, 253, 248, 0.7) 98.47%), radial-gradient(4009.6% 10453.55% at 0% 0%, #7EF8FE 0%, #7ABFEC 30.21%, #AEC3ED 45.54%, #DEF3F6 61.46%, #FAF9F3 100%)",
    blendMode: "normal, normal, normal",
    svgDefs: "<radialGradient id=\"gradient-3-bottomLayer\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\"\n      gradientTransform=\"rotate(60.6728) scale(36.75 1550.85)\">\n      <stop stop-color=\"#7EF8FE\" />\n      <stop offset=\"0.302083\" stop-color=\"#7ABFEC\" />\n      <stop offset=\"0.455396\" stop-color=\"#AEC3ED\" />\n      <stop offset=\"0.614583\" stop-color=\"#DEF3F6\" />\n      <stop offset=\"1\" stop-color=\"#FAF9F3\" />\n    </radialGradient>\n    <linearGradient id=\"gradient-3-middleLayer\" x1=\"-1.26123e-07\" y1=\"4.8\" x2=\"24\" y2=\"2.16\"\n      gradientUnits=\"userSpaceOnUse\">\n      <stop stop-color=\"#7CF6FB\" stop-opacity=\"0.48\" />\n      <stop offset=\"1\" stop-color=\"#FEFDF8\" stop-opacity=\"0.7\" />\n    </linearGradient>\n    <radialGradient id=\"gradient-3-topLayer\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\"\n      gradientTransform=\"translate(4.41 18) rotate(-52.9472) scale(22.5541)\">\n      <stop stop-color=\"#6AA0F2\" />\n      <stop offset=\"1\" stop-color=\"#C6E5F7\" stop-opacity=\"0\" />\n    </radialGradient>",
    svgDefIds: "gradient-3-bottomLayer,\n      gradient-3-middleLayer,\n      gradient-3-topLayer"
  }
};

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var border = {
  size: {
    600: "6px",
    500: "5px",
    400: "4px",
    300: "3px",
    200: "2px",
    100: "1px"
  }
};
var icon = {
  size: {
    600: "64px",
    500: "48px",
    400: "32px",
    300: "24px",
    250: "20px",
    200: "16px",
    100: "12px"
  }
};
var zLevel = {
  tooltip: 12,
  toast: 11,
  popover: 10,
  modal: 9,
  drawer: 8
};
var frost = {
  100: "blur(16px)",
  200: "blur(24px)",
  300: "blur(48px)",
  400: "blur(56px)",
  500: "blur(64px)",
  600: "blur(112px)"
};
var commonTokens = {
  spacing: spacing,
  borderRadius: borderRadius,
  font: font,
  text: text,
  breakpoint: breakpoint,
  icon: icon,
  border: border,
  zLevel: zLevel,
  motion: motion,
  frost: frost
};
var base = _objectSpread(_objectSpread({}, commonTokens), {}, {
  colorMode: "onLight",
  color: onLightColors,
  gradient: onLightGradients,
  shadow: onLightShadows
});
var onDarkBase = _objectSpread(_objectSpread({}, commonTokens), {}, {
  colorMode: "onDark",
  color: onDarkColors,
  gradient: onDarkGradients,
  shadow: onDarkShadows
});

var designTokens = {
  base: base
};
var version = packageData.version;
console.log("\n  @biom3/design-tokens\n  \n  version: ".concat(version, "\n\n"));

export { base as b, designTokens as d, onDarkBase as o };
//# sourceMappingURL=index2.js.map
